import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActionState } from 'src/app/enums/action-state.enum';
import { SubscriptionRepo } from 'src/app/repositories/subscription-repo';
import { BadgeRequest } from '../../models/badge/badge-request';

@Component({
    selector: 'app-modal-badges-unassign',
    templateUrl: './modal-badges-unassign.component.html',
    styleUrls: ['./modal-badges-unassign.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalBadgesUnassignComponent implements OnInit, OnDestroy {
  destroyed$ = new Subject<void>();
  loadingState = new BehaviorSubject(ActionState.LOADING);
  actionState = ActionState;
  error: any;

  badgesList: BadgeRequest[] = [];
  subsList: [] = [];
  bodyRequest!: { uid: string; name: string; subscriptionUid: any };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private subscriptionRepo: SubscriptionRepo
  ) {}

  ngOnInit(): void {
    this.subsList = this.data.userObj.subscriptionInfos;
    this.subsList.forEach((subs: any) => {
      this.getBadgesFromSubscription(subs.uid);
    });
  }

  onChangeBadge(uid: string, name: string, subscriptionUid: string) {
    this.bodyRequest = {
      uid: uid,
      name: name,
      subscriptionUid: subscriptionUid,
    };
  }

  setDefaultBodyRequest(badgeList: any[]) {
    const firstBadge = badgeList[0];
    this.bodyRequest = {
      uid: firstBadge.uid,
      name: firstBadge.value,
      subscriptionUid: firstBadge.subscriptionUid,
    };
  }

  getBadgesFromSubscription(uid: string) {
    this.loadingState.next(ActionState.LOADING);
    this.subscriptionRepo
      .getBadgesFromSubscription(uid)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (res: BadgeRequest[]) => {
          this.loadingState.next(ActionState.READY);
          res.forEach((badge: BadgeRequest) => {
            badge.customerAccountId = uid;
          });
          this.badgesList = [...this.badgesList, ...res];
          this.setDefaultBodyRequest(this.badgesList);
        },
        error: (error) => {
          this.error = error.error;
          this.loadingState.next(ActionState.FAILED);
        },
      });
  }

  onSubmit() {
    this.loadingState.next(ActionState.LOADING);
    const subscriptionUid = this.bodyRequest.subscriptionUid;
    const body = { uid: this.bodyRequest.uid };
    this.subscriptionRepo
      .unassignBadgeFromSubscription(subscriptionUid, body)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (res) => {
          this.loadingState.next(ActionState.SUCCESS);
        },
        error: (error) => {
          this.error = error.error;
          this.loadingState.next(ActionState.FAILED);
        },
      });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
